const sortSelect = document.querySelector('#sort-select')

function sortHalls () {
  const halls = document.querySelectorAll('.conference-hall')
  sortSelect.addEventListener('change', () => {
    for (const hall of halls) {
      hall.style.order = hall.dataset[sortSelect.value] || 100000
    }
  })
}

if (sortSelect) sortHalls()
